


import React, { Component, useEffect, useState } from 'react'
import {Box, Card, Paper,Divider, Grid2,Typography,IconButton,Checkbox, Button} from '@mui/material'
import { ToastContainer, toast } from 'react-toastify';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import CallIcon from '@mui/icons-material/Call';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import checkbox from 'rc-checkbox';
import { useNavigate,useLocation, Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import base_url from './base_url';
import regg from '../src/lr.jpg'


import bg2 from './bachround_img/bg.jpg'
import bg from './bachround_img/bg2.jpg'
import bg3 from './bachround_img/bg3.jpg'
import bg4 from './bachround_img/bg4.jpg'
import bg5 from './bachround_img/bg5.png'

import product1 from './product_img/product1.png'

function Become_sellers(props) {
  const navigate = useNavigate()
  const location = useLocation()

  const [showpassword,SetshowPassword] =useState(true);


  const [seller_name,Setseller_name] =useState("");
  const [email,Setemail] =useState("");
  const [phone,Setphone] =useState("");
  const [phone_2,Setphone_2] =useState("");
  const [seller_address,Setseller_address] =useState("");
  const [password,Setpassword] =useState("");



function registerSellerHere(){
  if(email!=="" && phone!=="" && password!=="" && phone_2!=="" && seller_address!=="" && seller_name!==""){
  fetch(`${base_url.base}/sellers/registerSellers`, {
    headers: {
      "content-type": "application/json",
    },
    method: "post",
    body:JSON.stringify({
      seller_name : seller_name,
email : email,
password : password,
phone:phone,
phone_2:phone_2,
seller_address:seller_address,

    })
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      if(result.status){
        localStorage.setItem('seller_email' , email);
         registerSucessfull()
        window.open('https://sellers.kichaarojes.in')
      }else{
        registerFail()
      }
    });

  }else{
    fillAllFields()
  }

  }




  function fillAllFields(){
    toast.warn('Fill All Fields', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
     theme: "colored"
     // transition: Bounce,
      });
  }




function registerSucessfull(){
  toast.success('Registration sucessfull', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
   theme: "colored"
   // transition: Bounce,
    });
}


function registerFail(){
  toast.error('Registration Failed', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
    //transition: Bounce,
    });
}



  return (
    <div>
     <Box sx={{backgroundColor:"#f8f9ff",width:'100%',height:'100vh',
            backgroundImage: `url(${bg2})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',}}>
    <Box sx={{display:'flex',justifyContent:'center'}}>
    <Box sx={{display:'flex',alignItems:'center',height:{xs:500,sm:500},width:{xs:'90%',sm:600,md:800},position:'absolute',top:80}}>
    <Card sx={{height:'100%',width:'100%',borderRadius:1}}>
    
    <Grid2 container spacing={1}>
      <Grid2 item  size={{xs:0,sm:6}}  sx={{display:{xs:'none',sm:'block'}}}>
      <Box sx={{display:'flex',justifyContent:'center'}}>
    <Box sx={{display:'flex',alignItems:'center',height:{xs:500,sm:500},width:'100%',backgroundColor:'pink'}}>
 
      <img src={regg} style={{height:'100%',width:'100%',objectFit:'cover'}}/>
  
    </Box>
      </Box>
      </Grid2>
    
      <Grid2 item size={{xs:12,sm:6}}>
      <Box sx={{display:'flex',justifyContent:'center',width:'100%',overflow:'scroll'}}>
    <Box sx={{display:'flex',alignItems:'center',width:'100%'}}>
      <Box sx={{display:'flex',flexDirection:'column',width:'100%'}}>
    
    <Box sx={{height:500,marginLeft:3,marginRight:{xs:3,sm:8}}}>
    <Typography sx={{textAlign:'left',fontSize:{xs:16,sm:20},fontWeight:'800',marginTop:5}}>Become a seller</Typography>
    

    <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:3,marginBottom:0.1}}>Sellers Name</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
    size='small'
    sx={{padding:0.5,"& input::placeholder": {
        fontSize: "13px"
      }}}
    fullWidth
            id="input-with-icon-textfield"
            placeholder=' Sellers name'
            name='seller_name'
            onChange={(e)=>Setseller_name(e.target.value)}
            value={seller_name}
            InputProps={{
                disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{color:'#a2a2a6'}} />
                </InputAdornment>
              ),
            }}
            variant="standard"
          />
    
    </Box>
    



    <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Email id</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
    size='small'
    sx={{padding:0.5,"& input::placeholder": {
        fontSize: "13px"
      }}}
    fullWidth
            id="input-with-icon-textfield"
            placeholder='Email id'
            name='email'
            onChange={(e)=>Setemail(e.target.value)}
            value={email}
            InputProps={{
                disableUnderline: true,
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon style={{color:'#a2a2a6'}} />
                </InputAdornment>
              ),
            }}
            variant="standard"
          />
    
    </Box>
    
    
    
    
    <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Phone no</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
              id="filled-start-adornment"
              sx={{padding:0.5,"& input::placeholder": {
                fontSize: "13px"
              }}}
              name="Phone 10 digit"
              value={phone}
            onChange={(e)=>Setphone(e.target.value)}
              placeholder='Phone 10 digit'
              size='small'
              fullWidth
           
              InputProps={{  
                disableUnderline: true,
                startAdornment: (
                    <InputAdornment position="start">
                     <CallIcon style={{color:'#a2a2a6'}} />
                    </InputAdornment>
                  ),
              }}
              variant="standard"
            />
    
    </Box>


        <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Phone no 2</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
              id="filled-start-adornment"
              sx={{padding:0.5,"& input::placeholder": {
                fontSize: "13px"
              }}}
              name="Phone 10 digit"
              value={phone_2}
            onChange={(e)=>Setphone_2(e.target.value)}
              placeholder='Phone 10 digit'
              size='small'
              fullWidth
           
              InputProps={{  
                disableUnderline: true,
                startAdornment: (
                    <InputAdornment position="start">
                     <CallIcon style={{color:'#a2a2a6'}} />
                    </InputAdornment>
                  ),
              }}
              variant="standard"
            />
    
    </Box>
    


    
    <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Address</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
    size='small'
    sx={{padding:0.5,"& input::placeholder": {
        fontSize: "13px"
      }}}
    fullWidth
            id="input-with-icon-textfield"
            placeholder='  Address here'
            name='seller_address'
            onChange={(e)=>Setseller_address(e.target.value)}
            value={seller_address}
            InputProps={{
                disableUnderline: true,
            }}
            variant="standard"
          />
    
    </Box>
    
    

    
    <Typography sx={{textAlign:'left',fontSize:{xs:11,sm:13},fontWeight:'600',marginTop:1,marginBottom:0.1}}>Password</Typography>
    <Box sx={{border:1,borderRadius:1,borderColor:'#a2a2a6'}}>
    <TextField
              id="filled-start-adornment"
              sx={{padding:0.5,"& input::placeholder": {
                fontSize: "13px"
              }}}
              name="password"
              value={password}
            onChange={(e)=>Setpassword(e.target.value)}
              placeholder='Your Password'
              size='small'
              fullWidth
              type= {showpassword?'text':'password'}
              InputProps={{  
                disableUnderline: true,
                endAdornment:(
                    <InputAdornment position="start">
                     {
                      showpassword? <Visibility style={{color:'#a2a2a6'}} onClick={()=>SetshowPassword(false)}/>:<VisibilityOff onClick={()=>SetshowPassword(true)} style={{color:'#a2a2a6'}}/> 
                     } 
                    </InputAdornment>
                  ),
                startAdornment: (
                    <InputAdornment position="start">
                     <LockIcon style={{color:'#a2a2a6'}} />
                    </InputAdornment>
                  ),
              }}
              variant="standard"
            />
    
    </Box>
    

    
    
    <Box sx={{marginTop:2,marginLeft:4,marginRight:4}}>
     
        <Button   type='submit'  onClick={registerSellerHere}  variant="contained" fullWidth size='small' sx={{backgroundColor:'#ab266c'}}>Become a seller</Button>
 
         <Button   type='submit'  onClick={()=>window.open('https://sellers.kichaarojes.in')} variant="contained" fullWidth size='small' sx={{backgroundColor:'#0d048a',mt:1}}>Login</Button>
 

    </Box>
    
    
    
    
    <br/>
    <br/>
    <br/>
    
    
    </Box>
      </Box>
    </Box>
    </Box>
 
      </Grid2>

    </Grid2>
    </Card>
    </Box>
    </Box>

    </Box>


    <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
//transition={Bounce}
/>

          </div>
  )
}

export default Become_sellers





























